import { Grabber } from '@/components/Grabber';
import { ListItem } from '@/components/List/ListItem';
import { useAppTranslation } from '@/hooks/useAppTranslation';
import { useSafeAreaPadding } from '@/hooks/useSafeAreaPadding';
import { Ionicons } from '@expo/vector-icons';
import { Separator, Sheet, SizableText, YStack, useTheme } from 'tamagui';

export type AddFileModalOption = {
  key: string;
  label: string;
  icon: 'image-outline' | 'camera-outline' | 'folder-open-outline';
  onPress: () => void;
};

interface AddFileModalProps {
  visible: boolean;
  options: AddFileModalOption[];
  onClose: () => void;
}

export const AddFileModal = ({
  visible,
  options,
  onClose,
}: AddFileModalProps): React.ReactElement => {
  const theme = useTheme();
  const { t } = useAppTranslation();
  const insets = useSafeAreaPadding();

  return (
    <Sheet
      open={visible}
      onOpenChange={onClose}
      snapPointsMode="fit"
      modal
      dismissOnSnapToBottom
    >
      <Sheet.Frame borderTopRightRadius="$modal" borderTopLeftRadius="$modal">
        <YStack
          backgroundColor="$background"
          padding="$true"
          paddingBottom={insets.bottomPadding}
          gap="$true"
        >
          <Grabber />
          <SizableText size="$h6" fontFamily="$bold">
            {t('speciesSearch.modals.addFileTitle')}
          </SizableText>
          <YStack>
            {options.map((option, index) => {
              const isLast = index === options.length - 1;
              return (
                <YStack key={option.key}>
                  <ListItem
                    title={option.label}
                    onPress={option.onPress}
                    iconBefore={
                      <Ionicons
                        name={option.icon}
                        size={20}
                        color={theme.color?.val}
                      />
                    }
                    iconAfter={
                      <Ionicons
                        name="chevron-forward"
                        size={18}
                        color={theme.color?.val}
                      />
                    }
                  />
                  {!isLast && <Separator borderColor="$tertiary" />}
                </YStack>
              );
            })}
          </YStack>
        </YStack>
      </Sheet.Frame>
      <Sheet.Overlay backgroundColor="$shadow" />
    </Sheet>
  );
};
